import clsx from "clsx";
import React, { FC } from "react";

interface FooterProps {
  title: string;
  time?: string;
  className?: string;
}

const Footer: FC<FooterProps> = ({ title, time, className }) => {
  return (
    <div
      className={clsx(
        "py-[17px] px-4 bg-gray-400 flex items-center justify-between flex-wrap",
        className,
      )}
    >
      <p className="uppercase font-semibold text-secondary text-sm leading-none">
        {title}
      </p>
      <p className="font-medium text-black text-sm leading-none">{time}</p>
    </div>
  );
};

export default Footer;
